import api from '@/api/_imagerieRapports'

const states = [
    { id: '', label: 'Tous' }, { id: 'to_perform', label: 'À réaliser' },
    { id: 'to_interpret', label: 'À interpréter' }, { id: 'draft', label: 'Brouillon' },
    { id: 'validated', label: 'Validé' }, { id: 'legacy', label: 'Archive' }
]
const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
export default {
    name: 'ImagerieRegistre',
    data() { return { groups: [], loading: true, error: false, query: '', type: '', state: '', page: 1, generation: 0, states,
        fields: [{key:'patient',label:'Patient'}, {key:'type_examen',label:'Examen'}, {key:'date',label:'Date'},
            {key:'cliches_count',label:'Clichés'}, {key:'imagerie_status',label:'État'}, {key:'actions',label:'Actions'}] } },
    computed: {
        rows() { return this.groups.reduce((all, group) => all.concat(Object.values(group.patients || {}).map(row => ({ ...row, type_examen_id: group.type_examen_id, type_examen: group.type_examen }))), []) },
        matching() { const q=normalize(this.query); return this.rows.filter(row => (!this.type || String(row.type_examen_id) === this.type) &&
            (!q || normalize([row.patient,row.type_examen,row.nom_prescripteur,row.telephone,row.renseignement_clinique,row.date].join(' ')).includes(q))) },
        visibleRows() { return this.matching.filter(row => !this.state || row.imagerie_status === this.state) },
        counts() { const result={'':this.matching.length}; this.matching.forEach(row => { result[row.imagerie_status]=(result[row.imagerie_status] || 0)+1 }); return result }
    },
    watch: { query() { this.page=1 }, type() { this.page=1 }, state() { this.page=1 } },
    mounted() { this.refresh() },
    beforeDestroy() { this.generation++ },
    methods: {
        async refresh() {
            const generation=++this.generation; this.loading=true; this.error=false
            try { const data=await api.registry(); if(generation===this.generation) { this.groups=Array.isArray(data)?data:[]; this.page=1 } }
            catch (_) { if(generation===this.generation) { this.groups=[]; this.error=true } }
            finally { if(generation===this.generation) this.loading=false }
        },
        label(state) { const item=states.find(s=>s.id===state); return item?item.label:'Non renseigné' },
        open(row) { this.$emit('open',{type_examen_id:row.type_examen_id,type_examen:row.type_examen},row) }
    }
}
